import { useState } from "react";
import { useOutletContext } from "react-router-dom";

import { ReactComponent as ArrowIcon } from "../../../images/arrow-small-left.svg";
import Select from "components/elements/Select";
import { FILE_STATUSES_REVERSE, FILE_TYPES_REVERSE } from "core/Constants";
import utility from "core/Utils";
import DateInput from "components/elements/DateInput";
import dataProvider from "core/DataProvider";
import { toast } from "react-hot-toast";
import FileDetailsOverview from "./FileDetailsOverview";
import FileDetailsDetailed from "./FileDetailsDetailed";
const { default: Header } = require("../../common/Header");

let yesterdayDate = new Date();
yesterdayDate.setDate(yesterdayDate.getDate() - 1);

const FileDetails = () => {
  const [data, setData] = useState([]);
  const [selectedDetails, setSelectedDetails] = useState(null);

  const [date, setDate] = useState(utility.formatDateForInput(yesterdayDate));
  const [type, setType] = useState(
    utility.optionFromObject(FILE_TYPES_REVERSE)
  );
  const [status, setStatus] = useState(
    utility.optionFromObject(FILE_STATUSES_REVERSE)
  );
  const [formCollapsed, setFormCollapsed] = useState(false);

  const token = useOutletContext();
  const { name, client_name } = token;

  const fetchData = async () => {
    const body = {
      date,
      type: type.map(x => parseInt(x.value)),
      status: status.map(x => parseInt(x.value)),
    };

    let data = [];

    try {
      data = await dataProvider.network.post("masters/files", body);
    } catch (error) {
      console.error({ error });
      toast.error("Failed to fetch data");
    }

    if (!data.length) {
      toast("No data found");
      return;
    }

    for (let i = 0; i < data.length; i++) {
      data[i].type = FILE_TYPES_REVERSE[data[i].type];
      data[i].status = FILE_STATUSES_REVERSE[data[i].status];
    }

    setData(data);
  };

  return (
    <div id="file-details" className="page">
      <Header user={name} client_name={client_name} title="File Details" />
      <section>
        <div className="flex mtop">
          <div
            className={
              formCollapsed ? "form-wrapper collapsed" : "form-wrapper"
            }
          >
            <div className={"form-segment"}>
              <div className="segment-body">
                <DateInput
                  value={date}
                  onChange={val => setDate(val)}
                  placeholder="Date"
                />
                <Select
                  isMulti={true}
                  options={utility.optionFromObject(FILE_TYPES_REVERSE)}
                  value={type}
                  onChange={val => setType(val)}
                  placeholder="File type"
                />
                <Select
                  isMulti={true}
                  options={utility.optionFromObject(FILE_STATUSES_REVERSE)}
                  value={status}
                  onChange={val => setStatus(val)}
                  placeholder="Status"
                />
              </div>
            </div>
            <button onClick={fetchData}>Submit</button>
            <div
              className="collapser"
              onClick={e => setFormCollapsed(!formCollapsed)}
            >
              <ArrowIcon />
            </div>
          </div>
          {selectedDetails ? (
            <FileDetailsDetailed
              data={data}
              showDetails={setSelectedDetails}
              selectedDetails={selectedDetails}
            />
          ) : (
            <FileDetailsOverview data={data} showDetails={setSelectedDetails} />
          )}
        </div>
      </section>
    </div>
  );
};

export default FileDetails;
